"use client";

import { Button } from "@workspace/ui/components/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@workspace/ui/components/dialog";
import { signOut } from "next-auth/react";
import { useRouter, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

export const AccessRestrictedDialog = () => {
  const router = useRouter();
  const [dialogOpen, setDialogOpen] = useState(false);
  const searchParams = useSearchParams();
  const errorParam = searchParams ? searchParams.get("error") : null;

  useEffect(() => {
    if (errorParam == null || errorParam !== "AccessDenied") {
      setDialogOpen(false);
    } else {
      setDialogOpen(true);
    }
  }, [errorParam]);

  return (
    <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Access restricted</DialogTitle>
          <DialogDescription>
            CodeWords* is currently in private beta. <br />
            If you&apos;d like to get early access, please email
            support@agemo.ai or sign up to the waitlist on this page.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            onClick={() => {
              void signOut();
              router.replace("/login");
            }}
          >
            OK
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
